// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  surfaceId: __t.u64().primaryKey().name("surface_id"),
  assetRef: __t.string().name("asset_ref"),
  name: __t.string(),
  assetId: __t.u64().name("asset_id"),
  layerOrder: __t.i32().name("layer_order"),
  enabled: __t.bool(),
  isGround: __t.bool().name("is_ground"),
  clipsGround: __t.bool().name("clips_ground"),
  geoOriginLon: __t.f64().name("geo_origin_lon"),
  geoOriginLat: __t.f64().name("geo_origin_lat"),
  geoOriginAlt: __t.f64().name("geo_origin_alt"),
  geoHeadingDeg: __t.f64().name("geo_heading_deg"),
  footprintGeojson: __t.string().name("footprint_geojson"),
  twinId: __t.option(__t.string()).name("twin_id"),
  updatedAt: __t.timestamp().name("updated_at"),
});
